import React from 'react'

export default function ButtonArrow(props: any) {
  return (
    <svg width="16" height="17" style={{ rotate: props.rotate ? props.rotate : '' }} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.44652 3.81688L7.99965 8.50001L3.44652 13.1831C3.25519 13.382 3.25519 13.6965 3.44652 13.8953L5.20339 15.7025C5.39252 15.8992 5.70739 15.8992 5.89659 15.7025L12.5535 8.85608C12.7448 8.65728 12.7448 8.34274 12.5535 8.14394L5.89652 1.29754C5.70739 1.10081 5.39252 1.10081 5.20339 1.29754L3.44652 3.10474C3.25519 3.30354 3.25519 3.61801 3.44652 3.81688Z" fill={props.fill ? props.fill : 'white'} />
    </svg>
  )
}
